/* Frosteam - etat vide du panier : onglets + rotation unique (V8, 16 oct. 2026).
   - Rotation Steam > Cold > Aroma > Steam, 3 s par onglet, EN BOUCLE tant que le tiroir est ouvert
     (16 oct. 19h20, comme la page /cart) ; page /cart : en boucle des que la photo est visible.
     Un onglet choisi par le client est respecte jusqu'a la fermeture du tiroir (19h05).
     Ouverture detectee par deux signaux (attribut open + evenement du theme), un seul demarrage.
   - Arret definitif au clic, toucher, clavier, molette/defilement, ou a la fermeture du tiroir.
   - Le theme recharge parfois le contenu du tiroir APRES l'ouverture (fiche produit) : un module insere
     dans un tiroir deja ouvert demarre aussi la rotation (19h35).
   - Aucune rotation si l'appareil demande de reduire les animations.
   - Echec d'ajout au panier : message visible (.fr-ritual__err), meme apres le rechargement du tiroir. */
(function () {
  if (window.customElements.get('frosteam-ritual')) return;
  var STEP = 3000;
  var ERR_TTL = 15000;
  var lastErr = 0;
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  var MSG = {
    en: "Harmony couldn't be added. Please try again or add it from the product page.",
    fr: "Harmony n'a pas pu être ajouté. Réessayez ou ajoutez-le depuis la page produit.",
    es: 'No se pudo añadir Harmony. Inténtalo de nuevo o añádelo desde la página del producto.'
  };
  function showErr() {
    if (!lastErr || Date.now() - lastErr > ERR_TTL) return;
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var boxes = document.querySelectorAll('.fr-ritual__buy');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].querySelector('.fr-ritual__err')) continue;
      var p = document.createElement('p');
      p.className = 'fr-ritual__err';
      p.setAttribute('role', 'alert');
      p.textContent = MSG[lang] || MSG.en;
      var trust = boxes[i].querySelector('.fr-ritual__trust');
      boxes[i].insertBefore(p, trust);
    }
  }
  document.addEventListener('cart:error', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.fr-ritual__buy')) { lastErr = Date.now(); showErr(); }
  });
  document.addEventListener('cart:change', function () { lastErr = 0; });
  /* Prestige masque le pied du tiroir quand le panier devient vide tiroir ouvert (l'etat vide
     d'origine n'a pas de pied). Ici le pied porte le prix + le bouton : on le reaffiche. */
  function restoreFoot(d) {
    if (!d || !d.shadowRoot || !d.querySelector('.fr-ritual-foot')) return;
    var f = d.shadowRoot.querySelector('[part~="footer"]');
    if (!f || getComputedStyle(f).opacity === '1') return;
    if (f.getAnimations) f.getAnimations().forEach(function (a) { a.cancel(); });
    f.style.opacity = '1';
    f.style.transform = 'none';
    if (!reduced() && f.animate) {
      f.animate([{ opacity: 0, transform: 'translateY(30px)' }, { opacity: 1, transform: 'none' }],
        { duration: 250, easing: 'cubic-bezier(.25,.46,.45,.94)' });
    }
  }
  document.addEventListener('cart-drawer:refreshed', function (e) { restoreFoot(e.target); });
  /* Page chargee avec un panier plein : ce script n'arrive qu'avec le nouveau contenu du tiroir,
     apres l'evenement ci-dessus. Verification immediate si le tiroir est deja ouvert. */
  (function () { var d = document.getElementById('cart-drawer'); if (d && d.hasAttribute('open')) restoreFoot(d); })();

  class FrosteamRitual extends HTMLElement {
    connectedCallback() {
      var self = this, wasInit = !!this._init;
      /* Le theme peut retirer puis reinserer le contenu du tiroir (ex. a la fermeture) :
         initialisation une seule fois, pour garder l'onglet choisi et eviter les ecouteurs en double. */
      if (!this._init) {
        this._init = true;
        this._stop = function () { self.stop(); };
        this._onShow = function () { self.onShow(); };
        this._onHide = function () { clearTimeout(self._openT); self.stop(); self.manual = false; self._started = false; };
        this.benefit = this.querySelector('.fr-ritual__benefit');
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('.fr-ritual__tab'));
        this.tabs.forEach(function (b) {
          b.addEventListener('click', function () { self.manual = true; self.stop(); self.select(b.getAttribute('data-tab')); });
        });
        ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function (ev) {
          self.addEventListener(ev, self._stop, { passive: true });
        });
        this.select('steam');
      }
      showErr(); setTimeout(showErr, 0);
      if (this.getAttribute('data-context') === 'page') { this.startPage(); return; }
      if (this.getAttribute('data-context') !== 'drawer') return;
      this.drawer = this.closest('cart-drawer') || document.getElementById('cart-drawer');
      if (!this.drawer) return;
      /* Tiroir cache = images differees jamais chargees avant la 1re ouverture (photo floue, tuiles grises).
         Prechargement discret 1,5 s apres le chargement de la page. */
      if (!this._warm) {
        this._warm = true;
        var imgs = this.querySelectorAll('img[loading="lazy"]');
        var warm = function () { for (var k = 0; k < imgs.length; k++) imgs[k].loading = 'eager'; };
        if (document.readyState === 'complete') setTimeout(warm, 1500);
        else window.addEventListener('load', function () { setTimeout(warm, 1500); }, { once: true });
      }
      this.drawer.addEventListener('dialog:after-show', this._onShow);
      this.drawer.addEventListener('dialog:after-hide', this._onHide);
      if (!this._mo && window.MutationObserver) {
        this._mo = new MutationObserver(function () {
          if (!self.drawer) return;
          if (self.drawer.hasAttribute('open')) { clearTimeout(self._openT); self._openT = setTimeout(self._onShow, 450); }
          else { self._onHide(); }
        });
      }
      if (this._mo) this._mo.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
      /* Module deplace ou recharge par le theme alors que le tiroir est deja ouvert : on demarre quand meme. */
      if (this.drawer.hasAttribute('open') && !this._started) {
        clearTimeout(this._openT); this._openT = setTimeout(this._onShow, 450);
      }
    }
    disconnectedCallback() {
      this.stop();
      clearTimeout(this._openT);
      if (this._mo) this._mo.disconnect();
      if (this.drawer) {
        this.drawer.removeEventListener('dialog:after-show', this._onShow);
        this.drawer.removeEventListener('dialog:after-hide', this._onHide);
      }
    }
    onShow() {
      var foot = this.drawer && this.drawer.querySelector('.fr-ritual-foot');
      if (foot && !foot.classList.contains('is-sweep')) foot.classList.add('is-sweep');
      if (this._started || (this.drawer && !this.drawer.hasAttribute('open'))) return;
      this._started = true;
      if (reduced() || this.manual) return;
      this.rotate(true);
    }
    startPage() {
      if (reduced() || this.manual || this._pageStarted) return;
      this._pageStarted = true;
      var self = this, target = this.querySelector('.fr-ritual__media') || this;
      if (!('IntersectionObserver' in window)) { this.rotate(true); return; }
      var io = new IntersectionObserver(function (es) {
        for (var k = 0; k < es.length; k++) {
          if (es[k].isIntersecting) { io.disconnect(); if (!self.manual) self.rotate(true); return; }
        }
      }, { threshold: 0.4 });
      io.observe(target);
    }
    rotate(loop) {
      this.stop();
      this.select('steam');
      var self = this, seq = ['cold', 'aroma', 'steam'], i = 0;
      this.rotating = true;
      if (this.benefit) this.benefit.setAttribute('aria-live', 'off');
      var step = function () {
        if (!self.rotating) return;
        self.select(seq[i % seq.length]);
        i += 1;
        if (loop || i < seq.length) { self.timer = setTimeout(step, STEP); } else { self.stop(); }
      };
      this.timer = setTimeout(step, STEP);
    }
    stop() {
      this.rotating = false; clearTimeout(this.timer);
      if (this.benefit) this.benefit.setAttribute('aria-live', 'polite');
    }
    select(tab) {
      this.setAttribute('data-active', tab);
      var nodes = this.querySelectorAll('[data-tab]');
      for (var n = 0; n < nodes.length; n++) {
        var el = nodes[n], on = el.getAttribute('data-tab') === tab;
        if (el.classList.contains('fr-ritual__tab')) { el.setAttribute('aria-pressed', on ? 'true' : 'false'); }
        else if (el.classList.contains('fr-ritual__img')) {
          el.classList.toggle('is-active', on);
          if (on) {
            var lq = this.querySelector('.fr-ritual__lq');
            if (lq && el.getAttribute('data-lq')) lq.style.backgroundImage = 'url(' + el.getAttribute('data-lq') + ')';
          }
        } else { el.hidden = !on; }
      }
    }
  }
  window.customElements.define('frosteam-ritual', FrosteamRitual);
})();
